import FeatureFlags from '../FeatureFlags';
import { getIOSVersion } from '../AppInfo';
import { APP } from '../../config';
import { inCommissionTierTest } from './commissionPricingTierTest';

/**
 * Determines whether or not a user should be allowed to directly create a pro account.
 *
 * @returns {Promise<Boolean>} True if not in the iOS app or if the
 *  `appt-variation-test` flag is enabled
 * @example
 * appointmentVariation.allowed().then(allowed => {
 *   if (allowed) {
 *     // Allow sign up as a pro
 *   } else {
 *     // Redirect to login...
 *   }
 * }).catch(() => {
 *   // Redirect to login...
 * });
 */
interface IAllowedArgs {
  /** Do this check using the flag only and ignore the commission checks */
  checkFlagOnly?: boolean;
}
export async function allowed(
  { checkFlagOnly = false }: IAllowedArgs = {},
): Promise<boolean> {
  const isIOSApp: boolean = !!(APP && getIOSVersion());
  const isAllowed = !isIOSApp || await FeatureFlags.isEnabled('appt-variation-test');

  if (checkFlagOnly) return isAllowed;
  return isAllowed || inCommissionTierTest();
}
